import React from 'react'
import { render } from 'react-dom'
import App from './App'
import 'Page.css'

import 'fontsource-roboto';

render(<App />, document.getElementById('root'))
